// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__0WSTo","disabled":"Video_disabled__DH8OQ"};